module.exports = __webpack_public_path__ + "img/goshare-logo.aadb61d4.png";